"use client"
import { useMemo } from "react";
import * as turf from "@turf/turf";

const FIT_BOUNDS_OPTIONS = { padding: { top: 20, bottom: 20, left: 20, right: 20 } };

// When the BOUNDARY system layer is shown, frame the map on the boundary instead of `fallback`
// (the locator's own default center), so the community is always centered. `dataBbox`
// ([minLon, minLat, maxLon, maxLat]), when given, is framed too so data outside the boundary stays in view.
export default function useBoundaryDefaultCenter(systemLayers, fallback, dataBbox) {
  const boundaryBbox = useMemo(() => {
    const boundary = systemLayers?.find(layer => layer.type === "BOUNDARY")?.geojson;
    if (!boundary?.features?.length) return null;
    return boundary.bbox?.length === 4 ? boundary.bbox : turf.bbox(boundary);
  }, [systemLayers]);

  const dataKey = dataBbox?.length === 4 ? dataBbox.join(",") : null;
  const frameBbox = useMemo(() => {
    if (!boundaryBbox || !dataKey) return boundaryBbox;
    return [
      Math.min(boundaryBbox[0], dataBbox[0]),
      Math.min(boundaryBbox[1], dataBbox[1]),
      Math.max(boundaryBbox[2], dataBbox[2]),
      Math.max(boundaryBbox[3], dataBbox[3])
    ];
  }, [boundaryBbox, dataKey]);

  const defaultCenter = useMemo(
    () => (frameBbox ? { fitBounds: frameBbox, fitBoundsOptions: FIT_BOUNDS_OPTIONS } : fallback),
    [frameBbox, fallback]
  );

  return { defaultCenter, boundingBox: boundaryBbox };
}
